const BASE_URL = 'https://docno-admin-aptest.hakaru-cloud.jp/v1/api-master'; // 検証環境API

export default BASE_URL;
